{
  "id": "campaign-040",
  "name": "Lawn Art",
  "seed": "campaign:40",
  "generatorVersion": 3,
  "level": 40,
  "biome": "park",
  "startDir": "N",
  "mowerRule": {
    "kind": "exclude",
    "mowers": ["fairway"]
  },
  "rows": [
    "^^^^^^^^^^^^",
    "^^^^...^^^^^",
    "^^^.....^^^^",
    "^^.......^^^",
    "^^.......^^^",
    "^^^.....^^^^",
    "^^^^...^^^^^",
    "^^^^^.^^^^^^",
    "^^..^.^..^^^",
    "^^^.....^^^^",
    "^^^^^.^^^^^^",
    "^^^^^.^^^^^^",
    "^^^^^^^^^^^^",
    "^^^^^^^^^^^^",
    "^^^^^^^^^^^^",
    "S^^^^^^^^^^^"
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 7,
      "y": 2
    }
  ],
  "critters": [],
  "art": {
    "pattern": [
      "............",
      "....|||.....",
      "...|||||....",
      "..||---||...",
      "..||---||...",
      "...|||||....",
      "....|||.....",
      ".....|......",
      "..--.|.--...",
      "...--|--....",
      ".....|......",
      ".....|......",
      "............",
      "............",
      "............",
      "............"
    ],
    "stars": [0.75, 0.9]
  },
  "par": {
    "reel": 4860,
    "push": 4316,
    "selfPropelled": 3984,
    "tractor": 3240,
    "zeroTurn": 2720
  }
}
